import { Box, Grid, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import theme from "../../theme";
import { AccountTree, CorporateFare, Person } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from '../../common/components/LoadingSpinner';
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { getStatics } from "../../api/staticPageApi";

const AdminDashboard = () => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.auth);
    const [dashBoardData, setDashBoardData] = useState(null);

    const getDashboardData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getStatics();
            setDashBoardData(response.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getDashboardData();
    }, []);

    return (
        <Grid container spacing={2}>
            {loading && (
                <LoadingSpinner />
            )}
            <Grid item md={4} sm={6} xs={12}>
                <CommonCard
                    borderRadius={1}
                    background={theme.palette.secondary.main}
                    content={
                        <Fragment>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                flexDirection="column"
                                gap={2}
                                p={2}
                            >
                                <Box
                                    sx={{
                                        background: theme.palette.primary.main,
                                        color: theme.palette.secondary.main,
                                        borderRadius: '50%',
                                        height: '57px',
                                        width: '57px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Person sx={{ fontSize: '30px' }} />
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography fontWeight={700} fontSize={20} color="white">Total Users</Typography>
                                    <Typography fontWeight={700} fontSize={18} color="white">{dashBoardData?.user}</Typography>
                                </Box>
                            </Box>
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <CommonCard
                    borderRadius={1}
                    background={theme.palette.secondary.main}
                    content={
                        <Fragment>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                flexDirection="column"
                                gap={2}
                                p={2}
                            >
                                <Box
                                    sx={{
                                        background: theme.palette.primary.main,
                                        color: theme.palette.secondary.main,
                                        borderRadius: '50%',
                                        height: '57px',
                                        width: '57px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <CorporateFare sx={{ fontSize: '30px' }} />
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography fontWeight={700} fontSize={20} color="white">Total Colleges</Typography>
                                    <Typography fontWeight={700} fontSize={18} color="white">{dashBoardData?.college}</Typography>
                                </Box>
                            </Box>
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <CommonCard
                    borderRadius={1}
                    background={theme.palette.secondary.main}
                    content={
                        <Fragment>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                flexDirection="column"
                                gap={2}
                                p={2}
                            >
                                <Box
                                    sx={{
                                        background: theme.palette.primary.main,
                                        color: theme.palette.secondary.main,
                                        borderRadius: '50%',
                                        height: '57px',
                                        width: '57px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <AccountTree sx={{ fontSize: '30px' }} />
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography fontWeight={700} fontSize={20} color="white">Total DCP Projects</Typography>
                                    <Typography fontWeight={700} fontSize={18} color="white">{dashBoardData?.dcp_project}</Typography>
                                </Box>
                            </Box>
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <CommonCard
                    borderRadius={1}
                    background={theme.palette.secondary.main}
                    content={
                        <Fragment>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                flexDirection="column"
                                gap={2}
                                p={2}
                            >
                                <Box
                                    sx={{
                                        background: theme.palette.primary.main,
                                        color: theme.palette.secondary.main,
                                        borderRadius: '50%',
                                        height: '57px',
                                        width: '57px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <AccountTree sx={{ fontSize: '30px' }} />
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography fontWeight={700} fontSize={20} color="white">Total External Projects</Typography>
                                    <Typography fontWeight={700} fontSize={18} color="white">{dashBoardData?.external_project}</Typography>
                                </Box>
                            </Box>
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <CommonCard
                    borderRadius={1}
                    background={theme.palette.secondary.main}
                    content={
                        <Fragment>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                flexDirection="column"
                                gap={2}
                                p={2}
                            >
                                <Box
                                    sx={{
                                        background: theme.palette.primary.main,
                                        color: theme.palette.secondary.main,
                                        borderRadius: '50%',
                                        height: '57px',
                                        width: '57px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <AccountTree sx={{ fontSize: '30px' }} />
                                </Box>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography fontWeight={700} fontSize={20} color="white">Total Projects</Typography>
                                    <Typography fontWeight={700} fontSize={18} color="white">{dashBoardData?.dcp_project + dashBoardData?.external_project}</Typography>
                                </Box>
                            </Box>
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
        </Grid>
    )
};

export default AdminDashboard;